export const REPORT_CONCERN_EVENT = 'chorepop:report-concern';

export type ReportableContentKind =
  | 'account'
  | 'chore'
  | 'routine'
  | 'goal'
  | 'deposit'
  | 'withdrawal'
  | 'approval'
  | 'other';

/**
 * The exact record the user was looking at when they chose Report.
 * Local ids are server-correlatable context, while the immutable snapshot
 * lets the operator review what the user actually saw even if the family
 * later edits or deletes the source record.
 */
export type ReportConcernContext = {
  contentKind: ReportableContentKind;
  contentLocalId: string;
  reportedLocalAccountId?: number;
  label: string;
  contentSnapshot: Record<string, unknown>;
};

export function openReportConcern(context: ReportConcernContext): void {
  window.dispatchEvent(
    new CustomEvent<ReportConcernContext>(REPORT_CONCERN_EVENT, { detail: context }),
  );
}
